import ServiceResponse from "@/types_and_interfaces/service_response_interface";
import fetchCms from "@/services/cms_interceptor";
// import qs from "qs";
// import {articles_per_page} from "@/utils/constants";
import CMS from "@/utils/cms.ts";


export const getDocument = async (doc_api_id:string):Promise<ServiceResponse> => {

    let response:ServiceResponse = {
        error: false
    }


    try {
        const req = await fetchCms(`/api/document/get/${doc_api_id}`);

        const res = await req.json()

        if(typeof res === "object" && res.hasOwnProperty("data")) {
            let raw_data = res.data?.types[0]
            if(raw_data) {
                response.response = CMS.getAllFields(raw_data)
            }
            
        } else {
            response.error = true
        }

        return response

    } catch (e) {
        response.error = true
        return response
    }

}

export const getModule = async (module_api_id:string) => {
    let response:ServiceResponse = {
        error: false
    }
    
    
    try {
        const req = await fetchCms(`/api/module/${module_api_id}/list`);
        
        const res = await req.json()
        
        if(typeof res === "object" && res.hasOwnProperty("data")) {
            response.response = res
            
        } else {
            response.error = true
        }
        
        return response
        
    } catch (e) {
        response.error = true
        return response
    }
}